import { lightBlue700, blueGrey50, blueGrey100 } from 'material-ui/styles/colors'

export const appBackground = blueGrey50
export const primaryBackground = lightBlue700
export const panelWidth = 200
export const collapseWidth = 68




// WEBPACK FOOTER //
// ./src/helpers/muiTheme/themeHelpers.js